import { getOrganisation } from '@/domain/organisation/actions/get-organisation.action';
import { Organisation } from '@/domain/organisation/entities/organisation.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  organisation: Organisation;
};

export const editOrganisation = createAppAsyncThunk(
  'organisation/editOrganisation',
  async (
    params: Params,
    { extra: { organisationGateway, snackbarGateway }, dispatch },
  ): Promise<void> => {
    try {
      await organisationGateway.editOrganisation(params.organisation);
      showSnackbarSuccess(snackbarGateway);
      dispatch(getOrganisation());
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('EditOrganisation.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('EditOrganisation.Message.error'));
}
